import HubEvent from "../../app/hub/event/HubEvent";
import NavigateEvent from "../../core/navigation/NavigateEvent";
import SkinFactory from "../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";

/**
* PlayVideoCommand.js
* 
* Created on Sep 26, 2013, 4:14:36 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class PlayVideoCommand {
    constructor(dispatcher, variableManager) {
        this._dispatcher = dispatcher;
        this._variableManager = variableManager;
    }

    execute({ params }) {
        //20230525, RF: why is this variable set here?? It doesnt occur anywhere else in the project.
        this._variableManager.setVariable('dialog_show_complete_popup', false);
        // Create skin
        this._moviePlayerSkin = SkinFactory.getSkin(SkinKeyRegistry.VIDEO_PLAYER_SKIN);
        this._moviePlayerSkin.content = params.data.content;
        this._moviePlayerSkin.contentPlayer = params.data.contentPlayer;
        this._moviePlayerSkin.onComplete = this._handleVideoComplete.bind(this);

        // Open screen
        const commandEvent = new NavigateEvent(NavigateEvent.OPEN_SCREEN_REQUEST, null, this._moviePlayerSkin, null, false);
        this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });
        //Hide hub
        this._dispatcher.dispatch(HubEvent.HIDE_REQUEST);
    }

    destroy() {
        //Nothing to do here, no event listeners etc to remove. Everything should be GC'ed automatically.
    }

    _handleVideoComplete() {
        // Show hub again
        this._dispatcher.dispatch(HubEvent.SHOW_REQUEST);
        // Close screen
        const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._moviePlayerSkin);
        this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });
        // Mark content as completed
        this._moviePlayerSkin.contentPlayer.contentCompleted(this._moviePlayerSkin.content);
        this.destroy();
    }

}